import DashboardTable from 'components/Dashboard';
import { usePanelMode } from 'contexts/PanelModeContext';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { checkPermission } from 'utils/utils';
import './index.scss';

export const Dashboard = () => {
  const selectedCompanyPermission = useSelector(
    (state: any) => state?.userProfile?.data?.permissions,
  );
  const { panelMode, canAccessMedicinePanel, canAccessGroceryPanel } =
    usePanelMode();

  const isDashboardPermission = checkPermission(selectedCompanyPermission, {
    permissionName: 'Dashboard',
    permission: ['view', 'viewAll'],
  });

  const canViewGroceryDashboard =
    panelMode === 'grocery' &&
    checkPermission(selectedCompanyPermission, {
      permissionName: 'GroceryItems',
      permission: ['view', 'viewAll'],
    });

  const showDashboard =
    isDashboardPermission || canViewGroceryDashboard;
  const hasDraftMedicinesRequestOnly = checkPermission(
    selectedCompanyPermission,
    {
      permissionName: 'DraftMedicinesRequest',
      permission: ['view', 'viewAll'],
    },
  );

  if (!showDashboard && hasDraftMedicinesRequestOnly) {
    return <Navigate to="/draft-medicines-request" replace />;
  }

  if (!showDashboard && canAccessGroceryPanel && !canAccessMedicinePanel) {
    return <Navigate to="/grocery-quality-check" replace />;
  }

  return (
    <div className="page-wrapper no-scroll">
      {showDashboard && <DashboardTable panel={panelMode} />}
    </div>
  );
};
